var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1583 3.72427C13.2992 3.0194 14.1689 2.75609 14.6772 3.26437L20.7364 9.32359C21.2447 9.83188 20.9814 10.7015 20.2765 10.8425L18.4759 11.2026C18.4132 11.2152 18.3556 11.246 18.3103 11.2913L15.4302 14.1714C15.3755 14.2261 15.3421 14.2986 15.3362 14.3757L14.9892 18.8872C14.9381 19.5513 14.3583 20.0483 13.6942 19.9972C13.4071 19.9751 13.1374 19.8511 12.9339 19.6475L9.28 15.993L4.5364 20.7372C4.18492 21.0886 3.61508 21.0886 3.2636 20.7372C2.94142 20.415 2.91457 19.9093 3.18306 19.5565L3.2636 19.4644L8.007 14.72L4.35324 11.0669C3.91365 10.6273 3.88435 9.9328 4.26532 9.45922L4.35324 9.36129C4.55681 9.15772 4.82649 9.03369 5.11354 9.01161L9.62502 8.66457C9.70217 8.65864 9.77465 8.6253 9.82937 8.57059L12.7095 5.69046C12.7547 5.64521 12.7856 5.58758 12.7981 5.52483L13.1583 3.72427ZM14.593 5.72577L14.5632 5.87784C14.4809 6.28905 14.2788 6.66672 13.9823 6.96326L11.1022 9.84338C10.7436 10.2019 10.2686 10.4204 9.76308 10.4593L6.539 10.7068L13.293 17.4608L13.5415 14.2377C13.5755 13.7953 13.747 13.3764 14.0296 13.0383L14.1574 12.8986L17.0375 10.0185C17.334 9.72195 17.7117 9.51982 18.1229 9.43758L18.274 9.40677L14.593 5.72577Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinOutline);
export default __webpack_public_path__ + "static/media/pin_outline.45138955322f969e8cf02459b856cf82.svg";
export { ForwardRef as ReactComponent };